import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryHub from './components/CategoryHub';
import TrendingSection from './components/TrendingSection';
import SEOContentHub from './components/SEOContentHub';
import TrustSection from './components/TrustSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryHub />
        <TrendingSection />
        <SEOContentHub />
        <TrustSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}